<div class="inputHeader-induxtry" *ngIf="passwordInput?.label">
    <span class="firstLabel" [ngStyle]="passwordInput?.styleLabel">
        {{ passwordInput.label }}
        <span class="optionalLabel" *ngIf="passwordInput?.subLabel" [ngStyle]="passwordInput?.styleSubLabel">{{passwordInput?.subLabel}}</span>
        <tooltip class="icon_tooltip" [tooltip]="{ text: passwordInput?.iconTooltip?.text, position: passwordInput?.iconTooltip?.position ? passwordInput?.iconTooltip?.position :'below' }">
            <mat-icon [svgIcon]="passwordInput?.iconTooltip?.icon"></mat-icon>
        </tooltip>
    </span>
    <span class="inputLength" *ngIf="passwordInput?.maxLength" [ngStyle]="passwordInput?.styleMaxLength" >({{ inputValue.value.length }}/{{passwordInput?.maxLength}})</span>
</div>
<mat-form-field warningInputInduxtry [warning]="warning" [required]="passwordInput?.required" [floatLabel]="'always'" appearance="outline" class="custom-outline-input-password"

>
    <input #inputValue matInput [placeholder]="passwordInput.placeholder" type="password" [required]="passwordInput?.required?.active"
        [(ngModel)]="passwordInput.value" [disabled]="passwordInput.disabled" [readonly]="passwordInput.readonly"
        (ngModelChange)="setValue()" [type]="hide ? 'password' : 'text'" [maxlength]="passwordInput?.maxLength" style="padding-top: 3px;" >

    <mat-icon 
   matSuffix (click)="hide = !hide" [svgIcon]="hide ? 'visibility_off' : 'visibility'"></mat-icon>

</mat-form-field>